import React from 'react';
import LottieLoader from '../../../components/LottieLoader';

/**
 * Loading state for the redesigned buckets screens.
 *
 * These pages showed bare "Loading…" text while the rest of the app (Stories,
 * Articles, brief generation) uses the Lottie loader, so they read as a
 * different product mid-load. One wrapper keeps every buckets surface on the
 * same animation and sizing.
 */
export default function BucketsLoading({ size = 220 }) {
  return (
    <div className="pbnew-loading">
      <LottieLoader size={size} />
    </div>
  );
}
